<template>
    <div class="container-fluid content mt-3 mt-md-0">
        <sakali-header title="Sondertipps"/>
        <div class="mt-4 row">
            <div class="col-12 col-md-4" v-for="specialBet in startedSpecialBets" :key="specialBet.id">
                <special-bet
                        :specialBet="specialBet"
                        class="mb-2"
                        @update:special-bet="updateSpecialBet($event)"/>
            </div>
        </div>
        <div v-if="specialBets.length == 0" class="text-center font-weight-bold mt-4 p-4">
            Aktuell gibt's keine Sondertipps
        </div>
    </div>
</template>

<script>
    import sakaliApi from '../sakali-api'
    import {mapGetters, mapActions} from 'vuex'
    import SpecialBet from '../components/bets/SpecialBet'

    export default {
        data() {
            return {
                specialBets: []
            }
        },
        computed: {
            ...mapGetters(['user']),
            startedSpecialBets(){
                let now = new Date().getTime();
                return this.specialBets.filter(sb => {
                    return new Date(sb.start) <= now
                })
            }
        },
        methods: {
            ...mapActions(['messageAction', 'handleErrorAction']),
            updateSpecialBet(specialBet) {
                let index = this.specialBets.map((sb) => {
                    return sb.id
                }).indexOf(specialBet.id)
                this.$set(this.specialBets, index, specialBet)
            }
        },
        created() {
            sakaliApi.get('/specialbets/current').then(response => {
                this.specialBets = response.data;
            }).catch(error => {
                this.handleErrorAction(error)
            })
        },
        components: {
            SpecialBet
        }
    }
</script>
